import { render, staticRenderFns } from "./mediaTab.vue?vue&type=template&id=48d8558f&"
import script from "./mediaTab.vue?vue&type=script&lang=js&"
export * from "./mediaTab.vue?vue&type=script&lang=js&"
import style0 from "./mediaTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports